module.exports = "<div id=\"{{id}}-popupWindow\"></div>\n\n";